import keys from "locale/keys";
import { useTranslation } from "react-i18next";

import CouponPlaceholder from "../../../assets/icons/CouponPlaceholder.svg";
import { AppCardProps } from "./interface";
import {
  AppCard,
  AppImage,
  AppName,
  CardContent,
  OpenAppButton,
  PointsBadge,
  PointsText,
} from "./styled.components";

const AppCardItem = ({ app }: AppCardProps) => {
  const { t } = useTranslation();
  const { name, appUrl, rewardPoints, imageURL } = app;

  const onOpenApp = () => {
    window.open(appUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <AppCard>
      <CardContent>
        <AppImage
          src={imageURL}
          alt={name}
          loading="lazy"
          onError={(e) => {
            e.currentTarget.src = CouponPlaceholder;
          }}
        />
        <PointsBadge>
          <PointsText>{rewardPoints} pts</PointsText>
        </PointsBadge>
        <AppName noWrap>{name}</AppName>
        <OpenAppButton variant="contained" fullWidth onClick={onOpenApp}>
          {t(keys.open_app)}
        </OpenAppButton>
      </CardContent>
    </AppCard>
  );
};

export default AppCardItem;
